module.exports = __webpack_public_path__ + "static/media/reedMonoK1007.77989e52.ico";